<template>
  <div>
    <b-modal
      v-model="showBoardLayout"
      hide-header
      hide-footer
      centered
      class="p-2"
      size="lg"
    >
      <b-img
        class="w-100"
        rounded
        alt="Logo"
        v-for="i in 6"
        :key="i"
        :src="require(`@/assets/images/board_layout_${i}.png`)"
      ></b-img>
    </b-modal>
    <div class="c-pointer mb-4" @click="$router.go(-1)">Cancel</div>
    <div class="d-flex mb-2">
      <h3>
        <b>Board Layout</b>
        <b-icon
          icon="question-circle"
          aria-label="Help"
          variant="primary"
          class="ml-2 c-pointer pb-1"
          font-scale="0.8"
          @click="showBoardLayout = true"
        ></b-icon>
      </h3>
    </div>

    <b-row :class="rowClass">
      <b-col>
        <b-form-group id="input-group-poles" class="col-12">
          <i
            class="clearable"
            v-show="form.number_of_poles"
            @click="form.number_of_poles = ''"
            >&times;</i
          >

          <b-form-input
            id="input-poles"
            v-model="form.number_of_poles"
            class="input-effect"
            :class="form.number_of_poles ? 'has-content' : ''"
            type="number"
            required
            aria-describedby="input-poles-feedback"
          ></b-form-input>
          <label>Number of poles</label>

          <div class="input-error" v-if="form.$getError('number_of_poles')">
            {{ form.$getError('number_of_poles')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-numbering-format" class="col-12">
          <b-img
            class="append-icon"
            :src="require('@/assets/icons/chevron-secondary.svg')"
            @click="select.numbering_format = !select.numbering_format"
          ></b-img>
          <b-form-input
            id="input-numbering-format"
            v-model="form.numbering_format"
            class="input-effect text-capitalize"
            :class="form.numbering_format ? 'has-content' : ''"
            :readonly="true"
            type="text"
            required
            aria-describedby="input-numbering-format-feedback"
            @focus="select.numbering_format = true"
            @blur="select.numbering_format = false"
          ></b-form-input>
          <label>Numbering format</label>

          <ul v-show="select.numbering_format" @mousedown.prevent>
            <li @click="onSelect('numbering_format', 'Horizontal')">
              Horizontal
            </li>
            <li @click="onSelect('numbering_format', 'Vertical')">Vertical</li>
            <li @click="onSelect('numbering_format', 'Blank')">Blank</li>
          </ul>

          <div class="input-error" v-if="form.$getError('numbering_format')">
            {{ form.$getError('numbering_format')[0] }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row :class="rowClass">
      <b-col>
        <b-form-group id="input-group-phase-colouring" class="col-12">
          <b-img
            class="append-icon"
            :src="require('@/assets/icons/chevron-secondary.svg')"
            @click="select.is_phase_colouring = !select.is_phase_colouring"
          ></b-img>
          <b-form-input
            id="input-phase-colouring"
            v-model="form.is_phase_colouring"
            class="input-effect"
            :class="form.is_phase_colouring ? 'has-content' : ''"
            :readonly="true"
            type="text"
            required
            aria-describedby="input-phase-colouring-feedback"
            @focus="select.is_phase_colouring = true"
            @blur="select.is_phase_colouring = false"
          ></b-form-input>
          <label>Phase colouring</label>

          <ul v-show="select.is_phase_colouring" @mousedown.prevent>
            <li @click="onSelect('is_phase_colouring', 'Yes')">Yes</li>
            <li @click="onSelect('is_phase_colouring', 'No')">No</li>
          </ul>

          <div class="input-error" v-if="form.$getError('is_phase_colouring')">
            {{ form.$getError('is_phase_colouring')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-phase-numbering" class="col-12">
          <b-img
            class="append-icon"
            :src="require('@/assets/icons/chevron-secondary.svg')"
            @click="select.is_phase_numbering = !select.is_phase_numbering"
          ></b-img>
          <b-form-input
            id="input-phase-numbering"
            v-model="form.is_phase_numbering"
            class="input-effect"
            :class="form.is_phase_numbering ? 'has-content' : ''"
            :readonly="true"
            type="text"
            required
            aria-describedby="input-phase-numbering-feedback"
            @focus="select.is_phase_numbering = true"
            @blur="select.is_phase_numbering = false"
          ></b-form-input>
          <label>Phase numbering</label>

          <ul v-show="select.is_phase_numbering" @mousedown.prevent>
            <li @click="onSelect('is_phase_numbering', 'Yes')">Yes</li>
            <li @click="onSelect('is_phase_numbering', 'No')">No</li>
          </ul>

          <div class="input-error" v-if="form.$getError('is_phase_numbering')">
            {{ form.$getError('is_phase_numbering')[0] }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row :class="rowClass">
      <b-col>
        <b-form-group id="input-group-neutral-numbers" class="col-12">
          <b-img
            class="append-icon"
            :src="require('@/assets/icons/chevron-secondary.svg')"
            @click="select.is_neutral_numbers = !select.is_neutral_numbers"
          ></b-img>
          <b-form-input
            id="input-neutral-numbers"
            v-model="form.is_neutral_numbers"
            class="input-effect"
            :class="form.is_neutral_numbers ? 'has-content' : ''"
            :readonly="true"
            type="text"
            required
            aria-describedby="input-neutral-numbers-feedback"
            @focus="select.is_neutral_numbers = true"
            @blur="select.is_neutral_numbers = false"
          ></b-form-input>
          <label>Neutral numbers</label>

          <ul v-show="select.is_neutral_numbers" @mousedown.prevent>
            <li @click="onSelect('is_neutral_numbers', 'Yes')">Yes</li>
            <li @click="onSelect('is_neutral_numbers', 'No')">No</li>
          </ul>

          <div class="input-error" v-if="form.$getError('is_neutral_numbers')">
            {{ form.$getError('is_neutral_numbers')[0] }}
          </div>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group id="input-group-board-colour" class="col-12">
          <b-img
            class="append-icon"
            :src="require('@/assets/icons/chevron-secondary.svg')"
            @click="select.board_colour = !select.board_colour"
          ></b-img>
          <b-form-input
            id="input-board-colour"
            v-model="form.board_colour"
            class="input-effect"
            :class="form.board_colour ? 'has-content' : ''"
            :readonly="true"
            type="text"
            required
            aria-describedby="input-board-colour-feedback"
            @focus="select.board_colour = true"
            @blur="select.board_colour = false"
          ></b-form-input>
          <label>Board colour</label>

          <ul v-show="select.board_colour" @mousedown.prevent>
            <li
              v-for="color in boardColours"
              :key="color.name"
              @click="onSelect('board_colour', color.name)"
            >
              {{ color.name }}
              <b-img
                v-bind="colorProps"
                rounded
                alt="Rounded image"
                :blank-color="color.hex"
              ></b-img>
            </li>
          </ul>

          <div class="input-error" v-if="form.$getError('board_colour')">
            {{ form.$getError('board_colour')[0] }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button
      class="mt-5"
      block
      variant="primary"
      :disabled="loading"
      @click="onSubmit"
    >
      <b-spinner class="mr-2" small v-show="loading"></b-spinner>Save
    </b-button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Form from '@/utils/form'
import { findIndex } from 'lodash'

const COLORS = [
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Cream', hex: '#F0E9DE' },
  { name: 'Grey', hex: '#909B93' },
  { name: 'Blue', hex: '#5B6E98' },
  { name: 'Orange', hex: '#DE8D45' },
  { name: 'Red', hex: '#B63824' },
  { name: 'Black', hex: '#000000' },
  { name: 'Green', hex: '#31573D' }
]

export default {
  computed: {
    ...mapState({
      board: state => state.board.boardDetails
    }),

    rowClass() {
      return this.isMobile ? 'd-block' : ''
    }
  },

  data() {
    return {
      loading: false,
      show: false,
      showBoardLayout: false,
      boardColours: COLORS,
      colorProps: {
        blank: true,
        width: 18,
        height: 18,
        border: '1px',
        borderColor: 'grey',
        position: 'absolute',
        right: true,
        class: 'mt-1'
      },
      select: {
        numbering_format: false,
        is_phase_colouring: false,
        is_phase_numbering: false,
        is_neutral_numbers: false,
        board_colour: false
      },
      form: new Form({
        number_of_poles: null,
        numbering_format: null,
        is_phase_colouring: null,
        is_phase_numbering: null,
        is_neutral_numbers: null,
        board_colour: null
      })
    }
  },

  methods: {
    ...mapActions({
      updateBoard: 'board/updateBoard'
    }),

    onSelect(field, value) {
      this.select[field] = false
      this.form[field] = value
    },

    resetForm() {
      this.form.board_id = this.board.board_id
      this.form.number_of_poles = this.board.number_of_poles
      this.form.numbering_format = this.board.numbering_format
      this.form.is_phase_colouring = this.board.is_phase_colouring
        ? 'Yes'
        : 'No'
      this.form.is_phase_numbering = this.board.is_phase_numbering
        ? 'Yes'
        : 'No'
      this.form.is_neutral_numbers = this.board.is_neutral_numbers
        ? 'Yes'
        : 'No'

      const colorIndex = findIndex(this.boardColours, {
        hex: this.board.board_colour
      })
      this.form.board_colour =
        colorIndex !== -1
          ? this.boardColours[colorIndex].name
          : this.board.board_colour
      this.form.$clearErrors()
    },

    formHasErrors() {
      const requiredField = 'This field is required.'
      this.form.$setErrors({
        number_of_poles: this.form.number_of_poles ? '' : [requiredField]
      })

      return this.form.$hasErrors()
    },

    async onSubmit() {
      if (!this.formHasErrors()) {
        this.loading = true
        const colorIndex = findIndex(this.boardColours, {
          name: this.form.board_colour
        })
        await this.updateBoard({
          board_id: this.form.board_id,
          number_of_poles: this.form.number_of_poles,
          numbering_format: this.form.numbering_format
            ? this.form.numbering_format.toLowerCase()
            : null,
          is_phase_colouring: this.form.is_phase_colouring
            ? this.form.is_phase_colouring === 'Yes'
            : null,
          is_phase_numbering: this.form.is_phase_numbering
            ? this.form.is_phase_numbering === 'Yes'
            : null,
          is_neutral_numbers: this.form.is_neutral_numbers
            ? this.form.is_neutral_numbers === 'Yes'
            : null,
          board_colour:
            colorIndex !== -1 ? this.boardColours[colorIndex].hex : null
        })
          .then(() => {
            this.resetForm()
            this.$router.push({
              name: 'board.board-details-page',
              params: {
                id: this.board.board_id,
                name: this.$route.params.site_name,
                is_updated: true
              }
            })
          })
          .catch(error => {
            this.form.$handleError(error)
          })
        this.loading = false
      }
    }
  },

  created() {
    this.$root.$on('boardLayoutLoaded', () => {
      this.resetForm()
    })
  }
}
</script>

<style lang="scss" scoped>
.append-icon {
  top: 16px;
  right: 14px;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.append-icon {
  z-index: 1;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}
.buttontext-2 {
  color: grey;
  font-size: 14px;
}
ul {
  position: absolute;
  z-index: 2;
  list-style-type: none;
  margin: 0;
  padding: 0;
  background: #f8f9fa;
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 2px;
  cursor: pointer;

  li {
    padding: 8px 16px;

    &:hover {
      background: #296dc529;
    }
  }
}
</style>
